import { registerLocaleData } from '@angular/common';
import localeEsVe from '@angular/common/locales/es-VE';
import {
  ErrorHandler,
  LOCALE_ID,
  type ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling, withNavigationErrorHandler } from '@angular/router';

import { routes } from './app.routes';
import { AuthService } from './core/auth/auth.service';
import { ManejadorErrores, esErrorDeCarga, recargarPorVersionNueva } from './core/errores/reporte-errores';
import { authInterceptor } from './core/http/auth.interceptor';
import { errorInterceptor } from './core/http/error.interceptor';
import { idempotenciaInterceptor } from './core/http/idempotencia.interceptor';
import { visitanteInterceptor } from './core/http/visitante.interceptor';
import { demoInterceptor } from './features/tutorial/demo.interceptor';
import { reconfirmarInterceptor } from './core/http/reconfirmar.interceptor';

// Fechas y números del framework en español de Venezuela (los montos usan el pipe dinero)
registerLocaleData(localeEsVe);

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'es-VE' },
    provideBrowserGlobalErrorListeners(),
    // D-159: los errores van al registro del dueño; una versión vieja se recarga sola
    { provide: ErrorHandler, useClass: ManejadorErrores },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'top' }),
      // Se publicó una versión nueva con la app abierta: la pantalla pedida se abre ya actualizada
      withNavigationErrorHandler((e) => {
        if (esErrorDeCarga(e.error)) recargarPorVersionNueva(e.url);
      }),
    ),
    // errorInterceptor primero en la request = último en ver el error: authInterceptor recibe
    // el HttpErrorResponse crudo para intentar el refresh antes de normalizarlo (patrón VendIA).
    provideHttpClient(withInterceptors([demoInterceptor, errorInterceptor, authInterceptor, reconfirmarInterceptor, idempotenciaInterceptor, visitanteInterceptor])),
    // Restaura la sesión (cookie vitrina_refresh → /auth/refresh → /auth/me) antes de renderizar
    provideAppInitializer(() => inject(AuthService).restaurarSesion()),
  ],
};
